import React from 'react';
import { DataTableColumn, DataTableProps } from '../../models/DataTable';

const DataTable = <T,>({ columns, data, sortBy, sortDirection, onSort, renderRow, disabled, sortingEnabled = true, emptyMessage }: DataTableProps<T>) => {
    const getSortIcon = (col: DataTableColumn) => {
        if (!sortingEnabled || !col.sortable) return null;
        if (sortBy !== col.key) return <i className="ri-expand-up-down-line" style={{ opacity: 0.3, marginLeft: '4px' }} />;
        return sortDirection === 'asc'
            ? <i className="ri-arrow-up-s-line" style={{ marginLeft: '4px' }} />
            : <i className="ri-arrow-down-s-line" style={{ marginLeft: '4px' }} />;
    };

    return (
        <table className="table">
            <thead>
                <tr>
                    {columns.map(col => (
                        <th
                            key={col.key}
                            onClick={sortingEnabled && col.sortable && !disabled ? () => onSort(col.key) : undefined}
                            style={sortingEnabled && col.sortable ? { cursor: disabled ? 'default' : 'pointer', userSelect: 'none', whiteSpace: 'nowrap', opacity: disabled ? 0.4 : 1 } : undefined}
                        >
                            {col.label}{getSortIcon(col)}
                        </th>
                    ))}
                </tr>
            </thead>
            <tbody>
                {data.map(item => renderRow(item))}
                {data.length === 0 && emptyMessage && <tr><td colSpan={columns.length}>{emptyMessage}</td></tr>}
            </tbody>
        </table>
    );
};

export default DataTable;
